$( document ).ready(function() {

  if ( $('#anchor-nav').length > 0 ) {

    var winWidth     = $(window).width();
    var nav          = $('#anchor-nav');
    var navTop       = nav.offset().top;
    var $window      = $(window);
    var banner       = $('.banner');
    var bannerHeight = banner.height();

    // Detect if banner has been scrolled past
    var anchorNavSticky = function() {

      var elemTop = $window.scrollTop();

      if ( elemTop > ( navTop - 90 ) ) {
        nav.addClass('sticky');
      } else {
        nav.removeClass('sticky');
      }

    };

    anchorNavSticky();

    $( window ).scroll( function(e) {
      anchorNavSticky();
    });

    $("#anchor-nav a").on('click', function(e) {

      e.preventDefault();

      var curEl           = $($(this).attr('href'));
      var curElOffset     = curEl.offset();
      var anchorNavHeight = $('#anchor-nav').hasClass('sticky') ? $('#anchor-nav').height() : 0;
      var totalOffset     = curElOffset.top - 165;

      $('html, body').animate({
        scrollTop: totalOffset + 'px'
      }, 750);

    });

  }

});
